import Modal from "react-responsive-modal";
import { ProductInclusion } from "../../../../../../graphql/operations";
import InclusionModalCard from "./InclusionModalCard";
import { Text } from "../../../../../Atoms/Typography";
import s from "./inclusionsModal.module.scss";

type InclusionModalProps = {
  open: boolean;
  onClose: () => void;
  inclusions: ProductInclusion[];
};

export default function InclusionsModal({
  open,
  onClose,
  inclusions,
}: InclusionModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      blockScroll={false}
      classNames={{
        modal: s.CustomModal,
      }}
    >
      <div>
        <div className={s.ModalContent}>
          <Text bold size="larger">
            What&apos;s included
          </Text>
        </div>
        <div>
          {inclusions.map((inclusion) => (
            <InclusionModalCard key={inclusion.id} inclusion={inclusion} />
          ))}
        </div>
      </div>
    </Modal>
  );
}
